export default "__VITE_ASSET__cf17e349__"